import { useFormikContext } from 'formik';
import { FC, useEffect } from 'react';

const ScrollToError: FC = () => {
  const { isValid, submitCount } = useFormikContext();

  useEffect(() => {
    if (!isValid) {
      const topbarHeight = document.querySelector('header.topbar')?.clientHeight || 0;
      const feedbackElement = document
        .querySelector('.feedback-invalid')
        ?.closest('.form-group')
        ?.getBoundingClientRect();

      if (feedbackElement) {
        window.scrollBy({
          top: feedbackElement.y - topbarHeight - 30,
          behavior: 'smooth',
        });
      }
    }
  }, [submitCount]);

  return null;
};

export default ScrollToError;
